module.exports = __webpack_public_path__ + "img/slika11.898e5bb9.jpg";